export interface Extent {
  XMAX: number
  XMIN: number
  YMAX: number
  YMIN: number
}

export namespace Extent {
  export const toLeafletExtent = (
    extentObject?: Extent
  ): L.BoundsLiteral | undefined => {
    return (
      extentObject && [
        [extentObject.YMIN, extentObject.XMIN],
        [extentObject.YMAX, extentObject.XMAX]
      ]
    )
  }
  export const fromLeafletExtent = (bounds: L.BoundsLiteral): Extent => {
    return {
      XMAX: bounds[1][1],
      XMIN: bounds[0][1],
      YMAX: bounds[1][0],
      YMIN: bounds[0][0]
    }
  }

  export const toLatLongBounds = (
    extentObject?: Extent
  ): L.LatLngBounds | undefined => {
    return (
      extentObject &&
      new L.LatLngBounds(
        new L.LatLng(extentObject.YMIN, extentObject.XMIN),
        new L.LatLng(extentObject.YMAX, extentObject.XMAX)
      )
    )
  }

  export const fromLatLngBounds = (bounds: L.LatLngBounds): Extent => {
    return {
      XMAX: bounds.getNorthEast().lng,
      XMIN: bounds.getSouthWest().lng,
      YMAX: bounds.getNorthEast().lat,
      YMIN: bounds.getSouthWest().lat
    }
  }

  export const fromBoundingBox = (
    bbox: string[],
    margin: number = 0
  ): Extent => {
    return {
      XMAX: parseFloat(bbox[3]) + margin,
      XMIN: parseFloat(bbox[2]) - margin,
      YMAX: parseFloat(bbox[1]) + margin,
      YMIN: parseFloat(bbox[0]) - margin
    }
  }
}
